import { action } from 'satcheljs';
import { MailFolder } from 'owa-graph-schema';
import { ActionSource } from 'owa-mail-store';

/**
 * Action to change archive tag for a folder
 * @param folder the selected folder
 * @param tagValue the new value selected
 * @param actionSource
 */
export const onArchiveTagForFolderChanged = action(
    'ON_ARCHIVE_TAG_FOR_FOLDER_CHANGED',
    (folder: MailFolder, tagValue: string, actionSource: ActionSource) => ({
        folder,
        tagValue,
        actionSource,
    })
);

/**
 * Action to change delete tag for a folder
 * @param folder the selected folder
 * @param tagValue the new value selected
 * @param actionSource
 */
export const onDeleteTagForFolderChanged = action(
    'ON_DELETE_TAG_FOR_FOLDER_CHANGED',
    (folder: MailFolder, tagValue: string, actionSource: ActionSource) => ({
        folder,
        tagValue,
        actionSource,
    })
);
